module.exports = __webpack_public_path__ + "img/people2.30d69467.png";